enum type {
	primary = 'primary',
	secondary = 'secondary',
	cancel = 'cancel'
}

enum size {
	medium = 'medium',
	small = 'small'
}

enum orientation {
	horizontal = 'horizontal',
	vertical = 'vertical'
}

export { orientation, size, type };
